export const primaryColor = '#57BC6E'
export const secondaryColor = '#F7F7F7'
